import { USER_LOGOUT, SET_USER } from './types';
import { removeToken } from '../functions/Auth';
import Axios from '../functions/Axios';
import { fetchModules } from './modulesActions';
import { saveToken } from 'functions/Auth';
import { API_URI } from '../Constant';
import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});

export const getUser = () => {
  return async (dispatch) => {
    try {
      const userData = await Axios.get(`${API_URI}/authentication/getusermetav2`);
      dispatch(setUser(userData.data));
    } catch (err) {
      removeToken();
      dispatch(logout());
    }
  };
};

export const authoriseUser = ({ credentials, history }) => {
  return async (dispatch) => {
    try {
      const loginResponse = await Axios.post(`${API_URI}/api/auth/signin`, credentials);
      saveToken(loginResponse.data.accessToken);
      history('/dashboard');
    } catch (err) { }
  };
};



export const USER_RIGHTS = {
  FullAccess: 2,
  Viewer: 0,
  Editor: 1
}



export const isAccess = (userRight, allowedRights = []) =>
  allowedRights.includes(userRight);

export const useHasAccess = (
  moduleID,
  allowedRights = [USER_RIGHTS.Editor, USER_RIGHTS.FullAccess]
) => {
  const { userRights = [] } = useSelector((state) => state.user);
  const rightsMap = useMemo(() => {
    return userRights.reduce((acc, right) => ({ ...acc, ...right }), {});
  }, [userRights]);
  if (moduleID === 0) {
    return (true);
  }
  // 🔹 MODE 1: Direct check
  if (moduleID !== undefined) {
    return isAccess(rightsMap[moduleID], allowedRights);
  }

  // 🔹 MODE 2: Return reusable function
  return (moduleID, allowedRights = [
    USER_RIGHTS.Editor,
    USER_RIGHTS.FullAccess,
  ]) => {
    if (moduleID === 0) {
      return (true);
    }
    return isAccess(rightsMap[moduleID]?? USER_RIGHTS.FullAccess, allowedRights);
  };
};


export const MODULE_IDS = {
  Collaterals: 1,
  PM: 2,
  Proposal: 3,
  DAM: 8,
  CRM: 4,
  CMS: 5,
};

export const useGetModuleID = (name) => {
  const modules = useSelector((state) => state.modules);

  // Build lookup map once
  const moduleMap = useMemo(() => {
    const map = {
      "Dashboard": 0,
    };

    modules?.forEach((element) => {
      map[element.moduleName] = element.moduleID;
      if (element.listOfSubModules?.length) {
        element.listOfSubModules.forEach((subEl) => {
          map[subEl.submduleName] = element.moduleID;
        });
      }
    });
    console.log(map,"mapmapmapmap");
    
    return map;
  }, [modules]);

  // Helper function
  const getModuleID = useCallback(
    (moduleName) => moduleMap[moduleName] ?? null,
    [moduleMap]
  );

  // 🔥 BOTH MODES
  return name ? getModuleID(name) : getModuleID;
};



export const logout = () => ({
  type: USER_LOGOUT,
});
